import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { bootcampWaittingListSchema } from '../../../utils/schema';
import ErrorMessage from '../../form/ErrorMessage';
import { Formik } from 'formik';
import { handleWaitListBootCamp } from '../../../redux/features/coach/actions/authAction';

const WaittingListBootCamp = ({ onClose, ID, handleClose }) => {
    const dispatch = useDispatch();

    const normalizePhoneValue = (value) => {
        if (!value) return "";
        const trimmed = String(value).trim();
        if (!trimmed) return "";
        if (trimmed.startsWith("+")) return trimmed;
        const digits = trimmed.replace(/\D/g, "");
        if (!digits) return "";
        return `+${digits}`;
    };

    const initialValues = {
        name: "",
        email: "",
        phone_number: "+230",
        notes: "",
        bootcamp_id: ID ?? "",
    };

    const handleSubmitDetails = async (values) => {
        const callback = (response) => {
            if (response.success) {
                handleClose();
            };
        };
        dispatch(handleWaitListBootCamp({ payload: values, callback }));
    };

    return (
        <div
            className="modal d-block ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog" style={{ maxWidth: "617px" }}>
                <div class="modal-content ">
                    <div class="modal-header border-0">
                        <button
                            type="button"
                            class="btn-close ct_circle_close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body px-5 pb-0">
                        <h4 class=" text-center mb-1 ct_fs_18  px-4">
                            Join the Waitlist
                        </h4>
                        <p class="mb-0 ct_grey_text px-4 ct_fs_14 text-center mx-auto" style={{ maxWidth: "320px" }} >
                            The Bootcamp is currently full but we'll let you know as soon as a spot opens
                        </p>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={bootcampWaittingListSchema}
                            enableReinitialize
                            onSubmit={(values, actions) => {
                                handleSubmitDetails(values);
                            }}
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                                setFieldError,
                            }) => (
                                <form onSubmit={handleSubmit} class="mt-4 ct_modal_scroll ct_custom_scroll px-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group mb-4">
                                                <label for="" class="d-block mb-2 ct_fs_14">Name</label>
                                                <input
                                                    type="text"
                                                    class="form-control ct_input ct_fs_14"
                                                    placeholder="Name"
                                                    id="name"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values?.name}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName="name"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group mb-4">
                                                <label for="" class="d-block mb-2 ct_fs_14">Email </label>
                                                <input
                                                    type="text"
                                                    class="form-control ct_input ct_fs_14"
                                                    placeholder="Email "
                                                    id="email"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values?.email}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName="email"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group mb-3">
                                                <label
                                                    class="mb-2 d-block ct_darkblue_text"
                                                >
                                                    Phone Number
                                                </label>
                                                <PhoneInput
                                                    id="phone_number"
                                                    className="form-control ct_input ct_input_grey_border_1 ct_border_radius_5 ct_h_44"
                                                    defaultCountry="MU"
                                                    value={normalizePhoneValue(values?.phone_number)}
                                                    onChange={(val) => {
                                                        const safeVal = val ?? "";
                                                        if (
                                                            typeof safeVal === "string" &&
                                                            safeVal.length > 2 &&
                                                            isValidPhoneNumber(safeVal)
                                                        ) {
                                                            setFieldValue(
                                                                "phone_number",
                                                                safeVal
                                                            );
                                                        } else if (
                                                            !isValidPhoneNumber(safeVal)
                                                        ) {
                                                            setFieldError(
                                                                "phone_number",
                                                                "Please enter valid phone number"
                                                            );
                                                            setFieldValue(
                                                                "phone_number",
                                                                safeVal
                                                            );
                                                        }
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName="phone_number"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group mb-4">
                                                <label for="" class="d-block mb-2 ct_fs_14">Notes(Optional) </label>
                                                <textarea
                                                    class="form-control ct_input ct_fs_14 h-auto" rows="4"
                                                    placeholder="Let the coach know what you will like to focus on....."
                                                    id="notes"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values?.notes}
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName="notes"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="d-flex align-items-center gap-3 justify-content-center pt-2"
                                    >
                                        <button class="ct_yellow_btn ct_sky_blue_btn px-5 ct_h_44" type="button" onClick={handleSubmit} >
                                            Join The Waitlist
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>

                </div>
                {/* <div class="modal-content" style={{
                    maxWidth: "1000px",
                    marginInline: "auto"
                }}>
                    <div class="modal-header border-0 p-0 pb-2">
                        <button
                            type="button"
                            class="btn-close ct_close_position_right12"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body pe-0">
                        <section class="ct_signup_main py-3">
                            <div class="container-fluid">
                                <div class="row align-items-center">
                                    <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto pe-0">
                                        <div class="ct_signup_right_content px-5 ct_custom_scroll">
                                            <div class="mt-0 text-center">
                                                <h2 class="ct_fs_32  mb-0 ct_darkblue_text mx-auto" style={{ maxWidth: "484px" }}>
                                                    Join the Waitling
                                                </h2>
                                                The Bootcamp is currently full but we'll let you know as soon as a spot opens
                                            </div>
                                            <Formik
                                                initialValues={initialValues}
                                                validationSchema={bootcampWaittingListSchema}
                                                enableReinitialize
                                                onSubmit={(values, actions) => {
                                                    handleLogin(values);
                                                }}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    setFieldValue,
                                                    setFieldError,
                                                }) => (
                                                    <form onSubmit={handleSubmit} class="mt-5">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label class="mb-2 d-block ct_darkblue_text">
                                                                        Name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="Name"
                                                                        id="name"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.name}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="name"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label class="mb-2 d-block ct_darkblue_text">
                                                                        Email
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control ct_input"
                                                                        placeholder="Email"
                                                                        id="email"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.email}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="email"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-3">
                                                                    <label

                                                                        class="mb-2 d-block ct_darkblue_text"
                                                                    >
                                                                        Phone Number
                                                                    </label>
                                                                    <PhoneInput
                                                                        id="phone_number"
                                                                        className="form-control ct_input ct_input_grey_border_1 ct_border_radius_5 ct_h_44"
                                                                        defaultCountry="MU"
                                                                        value={values?.phone_number}
                                                                        onChange={(val) => {
                                                                            const safeVal = val ?? "";
                                                                            if (
                                                                                typeof safeVal === "string" &&
                                                                                safeVal.length > 2 &&
                                                                                isValidPhoneNumber(safeVal)
                                                                            ) {
                                                                                setFieldValue(
                                                                                    "phone_number",
                                                                                    safeVal
                                                                                );
                                                                            } else if (
                                                                                !isValidPhoneNumber(safeVal)
                                                                            ) {
                                                                                setFieldError(
                                                                                    "phone_number",
                                                                                    "Please enter valid phone number"
                                                                                );
                                                                                setFieldValue(
                                                                                    "phone_number",
                                                                                    safeVal
                                                                                );
                                                                            }
                                                                        }}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="phone_number"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-12">
                                                                <div class="form-group mb-4">
                                                                    <label class="mb-2 d-block ct_darkblue_text">
                                                                        Notes (Optional)
                                                                    </label>
                                                                    <textarea
                                                                        type="text"
                                                                        rows={3}
                                                                        class="form-control"
                                                                        placeholder="Write any request you might have"
                                                                        id="notes"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values?.notes}
                                                                    />
                                                                    <ErrorMessage
                                                                        errors={errors}
                                                                        touched={touched}
                                                                        fieldName="notes"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-4">
                                                            <a class="ct_yellow_btn w-75 mx-auto ct_sky_blue_btn" onClick={handleSubmit}>
                                                                Confirm My Seat
                                                            </a>
                                                        </div>
                                                    </form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div> */}
            </div>
        </div>
    )
};

export default WaittingListBootCamp;
